import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StepperButton = styled(Button)({
  width: "109px",
}) as typeof Button;

